var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"title-chunk"},[_c('h2',[_vm._t("leftIcon"),_c('span',{staticClass:"title",style:({ fontSize: parseInt(_vm.size) + 'px' })},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"subTitle"},[_vm._v(_vm._s(_vm.secondTitle))]),_vm._t("right")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }